
import OTNTRefData from "../data/completeRefList.json"
import bibleBookList from "../data/BookChapterList.json"

function getBooksInTestament(testament) {
  const books = Object.keys(bibleBookList)
  const indexOfMat = books.indexOf("Mat")
  const OT = books.slice(0, indexOfMat)
  const NT = books.slice(indexOfMat)
  if (testament === "OT") {
    return OT
  } else {
    return NT
  }
}

function getVersesInBook(book) {
  const objs = Object.values(OTNTRefData)
  const verses = objs.filter(x => x.book === book)
  return verses
}

// ---------------------- //
// PIE CHART DATA
// ---------------------- //
export function getPerBookData(testament) {
  const chartData = {
    books: [],
    quotes: [],
    allusions: [],
    original: [],
    total: [],
  }
  const pieChart = {
    quotes: 0,
    allusions: 0,
    original: 0,
    total: 0,
  }
  getBooksInTestament(testament).forEach(book => {
    chartData.quotes.push(percentageOfVerses(book).quotes)
    pieChart.quotes = pieChart.quotes + percentageOfVerses(book).quotes
    chartData.allusions.push(percentageOfVerses(book).allusions)
    pieChart.allusions = pieChart.allusions + percentageOfVerses(book).allusions
    chartData.original.push(percentageOfVerses(book).original)
    pieChart.original = pieChart.original + percentageOfVerses(book).original
    chartData.total.push(percentageOfVerses(book).total)
    pieChart.total = pieChart.total + percentageOfVerses(book).verses
  })
  return {
    barChart: {
      labels: chartData.books,
      datasets: [
        {
          label: "Quotations",
          data: chartData.quotes,
          backgroundColor: "rgb(209, 0, 209)",
          borderColor: "purple",
          borderWidth: 1,
          hoverBackgroundColor: "purple",
          hoverBorderColor: "purple",
        },
        {
          label: "Allusions",
          data: chartData.allusions,
          backgroundColor: "rgb(255, 238, 4)",
          borderColor: "rgb(184, 171, 0)",
          borderWidth: 1,
          hoverBackgroundColor: "rgb(184, 171, 0)",
          hoverBorderColor: "rgb(184, 171, 0)",
        },
      ],
    },
    piechart: {
      datasets: [
        {
          data: [pieChart.quotes, pieChart.allusions, pieChart.original],
          backgroundColor: [
            "rgb(209, 0, 209)",
            "rgb(255, 238, 4)",
            "lightgrey",
          ],
          hoverBackgroundColor: ["purple", "rgb(184, 171, 0)", "grey"],
        },
      ],
    },
    testament: testament,
    pieChart,
  }
}

function percentageOfVerses(book) {
  const verses = getVersesInBook(book)
  const totalVerses = bibleBookList[book].verseCount
  const quotations = verses.filter(x => x.quotations.length > 0).length
  const allusions = verses.length - quotations
  return {
    verses: totalVerses,
    original: totalVerses - quotations - allusions,
    quotes: quotations,
    allusions: allusions,
  }
}
